<template>
  <div class="gp-main-body-content">
    <form @submit.prevent="agencyReg">
      <div class="container">
        <h1>Register</h1>
        <p>Please fill in this form to create an account.</p>
        <hr />

        <label for="email">
          <b>Email</b>
        </label>
        <input type="text" v-model="email" placeholder="Enter Email" name="email" required />

        <label for="psw">
          <b>Password</b>
        </label>
        <input type="password" v-model="password" placeholder="Enter Password" name="psw" required />

        <label for="psw-repeat">
          <b>Repeat Password</b>
        </label>
        <input
          type="password"
          v-model="passwordConfirm"
          placeholder="Repeat Password"
          name="psw-repeat"
          required
        />
        <hr />

        <p>
          By creating an account you agree to our
          <a href="#">Terms & Privacy</a>.
        </p>
        <button type="submit" class="registerbtn">Register</button>
      </div>

      <div class="container signin">
        <p>
          Already have an account?
          <a href="#">Sign in</a>.
        </p>
      </div>
    </form>
  </div>
</template>

<script>
import { Api, ApiUrl } from "@/services";

export default {
  name: "AgencyRegister",
  components: {},
  data() {
    return {
      email: "",
      password: "",
      passwordConfirm: ""
    };
  },
  computed: {},

  created() {},
  mounted() {},
  methods: {
    agencyReg() {
      let data = {
        user: this.email,
        pw: this.password,
        pw_rp: this.passwordConfirm
      };
      Api.base
        .post(ApiUrl.base.agency.register, data)
        .then(() => {
        })
        .catch(() => {
        });
    }
  }
};
</script>

<style lang="scss" scoped>


header {
  display: flex;

  .domain {
    color: $shade6;
  }

  .searchbox {
    margin-left: auto;
  }
}

h3 {
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
}

.banners {
  // margin-top: 30px;
  display: flex;
  flex-flow: row wrap;

  .sub-banners {
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    // margin-left: 24px;
    // width: calc(32.5% - 12px);
    @media (min-width: 1280px) {
      margin-top: unset;
    }
  }
}

.page-block-list {
  display: flex;
  flex-flow: row wrap;
  margin-left: -24px;
  margin-right: -24px;
}

::v-deep .page-block {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border-radius: 10px;
  flex: 1;
  // margin-left: 24px;
  margin-top: 24px;
  padding: 16px;
  // 228x318
  // min-width: calc(228px);
  min-height: calc(318px);
  // width: calc(25% - 24px);
  // max-width: calc(228px);
  // max-height: calc(318px);
}

.support-block,
.banner-block {
  flex: 1;
}

// .gp-main-body-content {
// }


* {
  box-sizing: border-box;
}

/* Add padding to containers */
.container {
  padding: 16px;
}

/* Full-width input fields */
input[type="text"],
input[type="password"] {
  width: 100%;
  padding: 15px;
  margin: 5px 0 22px 0;
  display: inline-block;
  border: none;
  background: #f1f1f1;
}

input[type="text"]:focus,
input[type="password"]:focus {
  background-color: #ddd;
  outline: none;
}

/* Overwrite default styles of hr */
hr {
  border: 1px solid #f1f1f1;
  margin-bottom: 25px;
}

/* Set a style for the submit/register button */
.registerbtn {
  background-color: #4caf50;
  color: white;
  padding: 16px 20px;
  margin: 8px 0;
  border: none;
  cursor: pointer;
  width: 100%;
  opacity: 0.9;
}

.registerbtn:hover {
  opacity: 1;
}

/* Add a blue text color to links */
a {
  color: dodgerblue;
}

/* Set a grey background color and center the text of the "sign in" section */
.signin {
  background-color: #f1f1f1;
  text-align: center;
}
</style>
